export default "__VITE_ASSET__7a6b7cbf__"